import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {ProductSearchService, SearchPageMetaResolver} from '@spartacus/core';
import {filter, map} from 'rxjs/operators';

@Component({
  selector: 'dcp-search-results-title',
  templateUrl: './search-results-title.component.html',
  styleUrls: ['./search-results-title.component.scss']
})
export class SearchResultsTitleComponent implements OnInit {
  total$: Observable<number> = this.productSearchService.getResults().pipe(
    filter((data) => !!data?.pagination),
    map((results) => results.pagination.totalResults)
  );

  query$: Observable<string>;

  title$: Observable<string>;

  constructor(
    protected productSearchService: ProductSearchService,
    protected searchPageMetaResolver: SearchPageMetaResolver,
  ) {
  }

  ngOnInit() {
    this.title$ = this.searchPageMetaResolver.resolveTitle();
    this.query$ = this.productSearchService.getResults().pipe(map(productSearchResult => productSearchResult.freeTextSearch));
  }
}
